import { enc, mode, pad } from "crypto-js";
import AES from "crypto-js/aes";
import { get } from "lodash";

const aesOptions = {
  mode: mode.CBC,
  padding: pad.Pkcs7,
};

export const encrypt = (data: string) =>
  AES.encrypt(data, get(process, "env.SECRET_PASS", ""), aesOptions).toString();

export const decrypt = (data: string) =>
  enc.Utf8.stringify(
    AES.decrypt(data, get(process, "env.SECRET_PASS", ""), aesOptions)
  );

export const decryptCustom = (data: string) => {
  const secret = process.env.NEXT_PUBLIC_EDITOR_SECRET_KEY || "";
  try {
    const decoded = atob(data);
    const parsed = JSON.parse(decoded);
    const key = enc.Utf8.parse(secret);
    const iv = enc.Base64.parse(parsed.iv);
    const decrypted = AES.decrypt(parsed.value, key, {
      iv: iv,
      ...aesOptions,
    });
    return decrypted.toString(enc.Utf8);
  } catch (error) {
    console.error("Decryption error:", error);
    return null;
  }
};
